export default class AxisLabels {
  public visible = false;
  public rotate = 0;

  constructor() {}

  public setVisibility(v: boolean) {
    this.visible = v;
  }

  public setRotation(r: number) {
    this.rotate = r;
  }
}
